import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiamondTurnRight } from '@fortawesome/free-solid-svg-icons';
import theme from '../../Theming/DefaultTheme';
var containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 150,
    width: '100%',
    padding: 5,
};
var detailsContainer = {
    flex: 1,
};
var placeTitleText = {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginBottom: 5,
};
var buttonContainer = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 6,
    width: '100%',
};
var PlaceCard = function (_a) {
    var place = _a.place, onPlaceAdded = _a.onPlaceAdded;
    var handlePlaceAdded = function (e) {
        e.stopPropagation(); // Prevent any other click action
        onPlaceAdded(place);
    };
    var googleMapsUrl = "https://www.google.com/maps/search/?api=1&query=".concat(encodeURIComponent(place === null || place === void 0 ? void 0 : place.address));
    return (_jsxs(Box, { style: containerStyle, children: [_jsxs(Box, { style: detailsContainer, children: [_jsx(Typography, { variant: 'h4', style: placeTitleText, children: place === null || place === void 0 ? void 0 : place.name }), _jsx(Typography, { variant: 'body2', children: place === null || place === void 0 ? void 0 : place.address }), _jsx(Typography, { variant: 'caption', style: {
                            color: theme.palette.grey[500],
                        }, children: "".concat(place === null || place === void 0 ? void 0 : place.distance, " miles away") })] }), _jsxs(Box, { style: buttonContainer, children: [_jsx(Button, { variant: 'contained', color: 'primary', sx: { width: 80, textTransform: 'none' }, onClick: handlePlaceAdded, children: "Add" }), _jsx(Button, { variant: 'contained', color: 'secondary', sx: { width: 160, textTransform: 'none' }, endIcon: _jsx(FontAwesomeIcon, { size: 'sm', icon: faDiamondTurnRight }), onClick: function () { return window.open(googleMapsUrl, '_blank'); }, children: "Directions" })] })] }));
};
export default PlaceCard;
